export enum CopilotChatRole {
  ASSISTANT = 'assistant',
  USER = 'user',
}

export enum CopilotChatMessageStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}
